import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { ReactComponent as PlusIcon } from '../../../assets/images/common/icons/circle-plus-icon.svg'
import { ReactComponent as DeleteIcon } from '../../../assets/images/common/icons/delete-icon.svg'
import { ReactComponent as TransferIcon } from '../../../assets/images/common/icons/transfer-icon.svg'
import { ReactComponent as RefundIcon } from '../../../assets/images/common/icons/history-icon.svg'
import InactiveMemberNotice from './InactiveMemberNotice'

import classes from './EnrollmentDetailDrawer.module.scss'

// The Drop/Refund, Transfer and Delete row shown above an enrollment's details. Shared by the
// Enrollments & Billing drawer and the Members drawer so the two cannot drift apart.
const EnrollmentActionButtons = ({ displayStatus, invoice, paidOnline, membershipInactive, onDrop, onRemove, onTransfer }) => {
  const { t } = useTranslation()
  const isPending = displayStatus === 'pending_approval'
  const isWaitlisted = displayStatus === 'waitlisted'
  const isDropped = displayStatus === 'dropped'
  const isCompleted = displayStatus === 'completed'

  if (isPending) { return null }

  const hasRefundableBalance = invoice?.status === 'paid' || invoice?.status === 'partially_refunded'
  const showRefundLabel = paidOnline || hasRefundableBalance

  if (isWaitlisted) {
    return (
      <div className={classes.actionButtons}>
        <button className={classes.actionButton} disabled>
          <PlusIcon className={classes.actionIcon} /> {t('enrollmentsBilling.drawer.addToProgram')}
        </button>
        <button className={classes.actionButton} disabled>
          {t('enrollmentsBilling.drawer.sendInviteLink')}
        </button>
        <button className={classNames(classes.actionButton, classes.pushRight)} disabled>
          <DeleteIcon className={classes.actionIcon} /> {t('enrollmentsBilling.drawer.remove')}
        </button>
      </div>
    )
  }

  // Completed or dropped enrollments can only be deleted, and only when not paid online.
  if (isDropped || isCompleted) {
    if (paidOnline) { return null }

    return (
      <>
        <div className={classes.actionButtons}>
          <button className={classes.actionButton} onClick={onRemove} disabled={membershipInactive}>
            <DeleteIcon className={classes.actionIcon} /> {t('enrollmentsBilling.drawer.delete')}
          </button>
        </div>
        {membershipInactive && <InactiveMemberNotice />}
      </>
    )
  }

  return (
    <>
      <div className={classes.actionButtons}>
        <button className={classes.actionButton} onClick={onDrop} disabled={membershipInactive}>
          <RefundIcon className={classes.actionIcon} />{' '}
          {showRefundLabel ? t('enrollmentsBilling.drawer.dropRefund') : t('enrollmentsBilling.drawer.drop')}
        </button>
        <button className={classes.actionButton} onClick={onTransfer} disabled={membershipInactive}>
          <TransferIcon className={classes.actionIcon} /> {t('enrollmentsBilling.drawer.transfer')}
        </button>
      </div>
      {membershipInactive && <InactiveMemberNotice />}
    </>
  )
}

EnrollmentActionButtons.propTypes = {
  displayStatus: PropTypes.string,
  invoice: PropTypes.object,
  paidOnline: PropTypes.bool,
  membershipInactive: PropTypes.bool,
  onDrop: PropTypes.func,
  onRemove: PropTypes.func,
  onTransfer: PropTypes.func,
}

export default EnrollmentActionButtons
